import { gql } from '@apollo/client';

export const GET_HIRER_ACCOUNT = gql`
  query GetHirerAccount($advertiserId: Int!) {
    hirerAccount(advertiserId: $advertiserId) {
      priceVisibility
      pricingModel
    }
  }
`;
